import { useEffect } from 'react'
import { useRegisterSW } from 'virtual:pwa-register/react'
import styles from './UpdateBanner.module.css'
import { t } from '../strings'

/**
 * La app nunca se actualiza sola: avisa y espera a que tú decidas, para no recargar a mitad
 * de una canción.
 */
export function UpdateBanner() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    offlineReady: [offlineReady, setOfflineReady],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisterError(error) {
      console.error('Service worker no registrado', error)
    },
  })

  // El aviso de «funciona sin conexión» es informativo: se cierra solo para no tapar nada.
  useEffect(() => {
    if (!offlineReady) return
    const timer = window.setTimeout(() => setOfflineReady(false), 6000)
    return () => window.clearTimeout(timer)
  }, [offlineReady, setOfflineReady])

  if (needRefresh) {
    return (
      <div className={styles.banner} role="status">
        <span>{t.pwa.updateReady}</span>
        <button className="primary" onClick={() => void updateServiceWorker(true)}>
          {t.pwa.updateNow}
        </button>
        <button onClick={() => setNeedRefresh(false)}>{t.pwa.later}</button>
      </div>
    )
  }

  if (offlineReady) {
    return (
      <div className={styles.banner} role="status">
        <span>{t.pwa.offlineReady}</span>
        <button onClick={() => setOfflineReady(false)}>{t.common.ok}</button>
      </div>
    )
  }

  return null
}
